import React from 'react'
import { baseUrl } from '@fs/zion-config'
import { Link } from '@fs/zion-router'
import { Button, H2, LayoutBand, Paragraph, Row, Separator, usePageWidth, WhiteTheme } from '@fs/zion-ui'
import { Trans, useTranslation } from 'react-i18next'

import constants from '../../utils/constants'

export default function FooterSection({ bgImage, mobileBgImage, whiteTheme, color, title = '', subtitle = '' }) {
  const { t } = useTranslation()
  const isMobile = usePageWidth()({ default: true, md: false })

  const Wrapper = whiteTheme ? WhiteTheme : React.Fragment
  const titleText = title || t('apac.nlihp.footer.heading', 'Ready to Start?')
  const subtitleText =
    subtitle || t('apac.nlihp.footer.subheading', 'Enjoy all the features of FamilySearch.org with a free account.')

  return (
    <LayoutBand image={isMobile ? mobileBgImage : bgImage} color={color} maxWidth="lg" marginY="xxl">
      <Wrapper>
        {isMobile && <Separator size="xxl" />}
        <H2 centered size={isMobile ? 'H1' : 'H3'} supplementary>
          {titleText}
        </H2>
        <Separator size="xs" />
        <Paragraph centered balanced size="sm">
          {subtitleText}
        </Paragraph>
        <Separator size="md" />
        <Row alignX="center">
          <Button
            data-testid="create-account-button"
            growX={isMobile}
            emphasis="high"
            color="gray"
            fullWidth={isMobile}
            to={`${baseUrl}${constants.URL_SIGNUP_CONNECT_TO_TREE}`}
            external
            linkName="button: create-account: click"
          >
            {t('apac.nlihp.footer.create-account.button', 'Create Account')}
          </Button>
        </Row>
        <Separator size="lg" />
        <Paragraph centered size="sm">
          <Trans
            i18nKey="apac.nlihp.footer.sign-in-statement"
            components={
              <Link
                data-testid="sign-in-link"
                external
                wayfinding
                to={`${baseUrl}/auth/login`}
                linkName="link: sign-in: click"
              />
            }
          >
            {'Or <0>sign in</0> if you already have an account.'}
          </Trans>
        </Paragraph>
        {isMobile && <Separator size="xxl" />}
      </Wrapper>
    </LayoutBand>
  )
}
